import { styled, YStack } from 'tamagui'

/**
 * Surface card (BuyerFlo design system): elevated background, hairline border,
 * large radius. Sits on the page background; holds tables, form sections, etc.
 */
export const Card = styled(YStack, {
    name: 'Card',
    backgroundColor: '$backgroundStrong',
    borderWidth: 1,
    borderColor: '$borderColor',
    borderRadius: 14,
    overflow: 'hidden',

    variants: {
        padded: {
            true: { padding: '$4' },
        },
        inset: {
            // for tables / lists that draw their own row padding
            true: { padding: 0 },
        },
    } as const,
})
